import { Component, inject, OnInit } from '@angular/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { GlobalErrorMessageService } from '@client/app/shared-modules/global-error-message/global-error-message.service';

@Component({
    selector: 'global-error-message',
    templateUrl: 'global-error-message.component.html',
    standalone: true,
    imports: [ConfirmDialogModule],
    providers: [ConfirmationService],
})

export class GlobalErrorMessageComponent implements OnInit {
    private readonly globalErrorMessageService = inject(GlobalErrorMessageService);
    private readonly confirmationService = inject(ConfirmationService);

    ngOnInit (): void {
        this.globalErrorMessageService.onNewErrorMessage.subscribe(msg => {
            this.confirmationService.confirm({
                key: 'globalErrorMessage',
                message: msg,
                dismissableMask: true,
            });
        });
    }

    onHide (): void {
        this.globalErrorMessageService.confirmError();
    }
}
